import type { CatalogRow } from './puntoEntregaModel.ts';

export function joinDateTime(fecha: string, hora: string): string {
  if (!fecha) return '';
  const h = hora && hora.length >= 4 ? hora : '00:00';
  return `${fecha}T${h}:00`;
}

export function splitDateTime(iso: string): { fecha: string; hora: string } {
  if (!iso) return { fecha: '', hora: '' };
  const [d, tRaw] = iso.split('T');
  const hora = (tRaw ?? '').slice(0, 5);
  return { fecha: d ?? '', hora };
}

import { gpsCoordsValid } from '@core/domain/utils/gpsCoordsValid.ts';

export function puntoEntregaLatLonValidos(lat: string, lon: string): boolean {
  return gpsCoordsValid(lat, lon);
}

/** Picks a valid entrega catalog id for `<select>` binding. */
export function resolveEntregaIdForSelect(entregas: ReadonlyArray<CatalogRow>, entregaId: number): number {
  if (entregas.length === 0) return 0;
  if (entregaId === 0) return 0;
  if (entregas.some((e) => e.id === entregaId)) return entregaId;
  return entregas[0]?.id ?? 0;
}
